import React from 'react';
import Link from 'next/link';
import { formatLocalizedDate } from '../../../utils/format-date';

const ArticleCard = ({
  author,
  thumbnail,
  date,
  title,
  category,
  slug,
  locale,
}) => {
  return (
    <article className="w-full sm:w-[calc(50%-20px)] mb-10 overflow-hidden translate-z-0">
      <Link
        href="/blog/[slug]"
        as={`/blog/${slug}`}
        className="article-list__image"
      >
        {typeof thumbnail !== 'undefined' ? (
          <div
            style={{
              backgroundImage: `url(${thumbnail})`,
            }}
            className="post-thumb"
          />
        ) : (
          <div className="post-thumb" />
        )}
      </Link>
      <div className="article-list-item__category mt-6">
        <p className="article-list-item__category--main">
          <Link
            href="/blog/category/[slug]"
            as={`/blog/category/${category?.slug}`}
          >
            {category.name}
          </Link>
        </p>
      </div>
      <h2 className="article-list-item__title">
        <Link href="/blog/[slug]" as={`/blog/${slug}`}>
          {title}
        </Link>
      </h2>
      <div className="author-name">
        <span className="author-name__by">
          by{' '}
          <Link href="/blog/author/[slug]" as={`/blog/author/${author?.slug}`}>
            {author?.name}
          </Link>
          , {formatLocalizedDate(date, locale)}
        </span>
      </div>
    </article>
  );
};

export default ArticleCard;
